import './login.css';
import config from "../../config.js";
import { Form, Input, Button, Row, Col } from 'antd';
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from 'react';
import { Navigate, Link } from "react-router-dom";

const Login = ({ onLogin }) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const onFinish = async () => {
        try {
            const response = await fetch(`${config.BASE_URL_IP}/wob/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },                                                                                                                                                                                                                                                    
                body: JSON.stringify({ username, password })
            });
            const data = await response.json();
            if (response.ok) {
                setLoggedIn(true);

                localStorage.setItem('userId',data.user.user_id);
                localStorage.setItem('userName',data.user.user_name);
                localStorage.setItem('designation',data.user.designation);
                localStorage.setItem('department',data.user.department);
                localStorage.setItem('department_id',data.user.department_id);
                localStorage.setItem('email',data.user.email_id);
                return <Navigate to="/workorder/wof/stats" />;
                // onLogin(username);
            } else {
                alert(data.msg);
            }
        } catch (err) {
            console.error('Failed:', err.message);
        }
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const onChange = () => { };

    if (loggedIn) {
        return <Navigate to="/workorder/wof/stats" />;
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <Form
                    name="login-form"
                    initialValues={{ remember: true }}
                    // onFinish={onFinish}
                    // onFinishFailed={onFinishFailed}
                >
                    <div class="signinlogospace">
                        <img class="signinlogo" src="https://nitttrc.edu.in/static/media/small.78fa84895b44f8ebc424.png" alt="NITTTR" />
                    </div>

                    {/* <p className="form-title">NITTTR WORKORDER MGMT</p>
                    <p>Login to the Dashboard</p> */}
                    {/* <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                        <Input placeholder="Username" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password placeholder="Password" />
                    </Form.Item> */}
                    <div className="inputspace">
                        <img className="icon" src="https://nitttrc.edu.in/static/media/user.6df9c9ef1a000f095321.webp" alt="User" />
                        <input
                            type="text"
                            className="input-field"
                            placeholder="USER ID"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="inputspace">
                        <img className="icon" src="https://nitttrc.edu.in/static/media/lock.8c940565b0eb157b286f.webp" alt="Password" />
                        <input
                            type="password"
                            className="input-field"
                            id="password"
                            placeholder="PASSWORD"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        <i className="fas fa-eye psw-icon toggle-password" style={{ marginLeft: 100 }}></i>
                    </div>

                      <Form.Item>
                      <ReCAPTCHA
                        sitekey="6LfcWtIqAAAAAAAzcp6ehvKt1mv338yvtVQWZ6Yu"
                       // sitekey="6LcrWKsrAAAAADcMZUm_nlhXoAFvVcVLx4gh1JuZ"

                        onChange={onChange}
                        style={{marginLeft:'30px', marginBottom:'20px'}}

                    />
                        <Row justify="space-between">
                            <Col>
                                <button type="button" onClick={onFinish} class="loginbtn" style={{fontWeight:'bolder'}}>
                                    LOGIN
                                </button>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Link to="/workorder/wof/login">
                        <Button type="link" style={{color:'white', marginLeft:'-110px'}}>
                            Back to Home
                        </Button>
                    </Link>
                    <Link to="/workorder/wof/login/forgot-password">
                        <Button type="link" style={{color:'white',float:'right',marginRight:'-130px'}}>
                            Forgot Password?
                        </Button>
                    </Link>
                </Form>
            </div>
        </div>
    );
};

export default Login;
